"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const brandedsnowsm = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-brandedsnowsm` : '') + (description ? ` desc-brandedsnowsm` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-brandedsnowsm"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-brandedsnowsm"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M19.93 5.94c0-1.54-1.1-2.8-2.54-3.07a4.67 4.67 0 0 0-8.3-.63 3.58 3.58 0 0 0-5.53 1.91C1.77 3.7 0 4.93 0 6.57c0 1.65 1.72 2.85 3.53 2.41a2.8 2.8 0 0 0 4.56.3 4.98 4.98 0 0 0 8.84-.21c1.67-.07 3-1.44 3-3.12Z",
    fill: "#D4D4D4"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m5.2 13.65-.63-.52.65-.5c.2-.16.24-.45.09-.66a.46.46 0 0 0-.66-.09l-.36.28v-.44a.47.47 0 1 0-.94 0v.42l-.32-.27a.47.47 0 0 0-.66.07c-.16.2-.13.5.07.66l.63.52-.64.5a.47.47 0 0 0-.09.65c.16.2.45.25.66.1v-.01l.35-.28v.45a.47.47 0 1 0 .94 0v-.42l.33.26c.2.17.49.15.66-.05.16-.2.14-.5-.06-.66l-.01-.02Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m18.53 13.65-.64-.52.65-.5c.2-.16.24-.45.09-.66a.47.47 0 0 0-.66-.09l-.36.28v-.44a.47.47 0 1 0-.93 0v.42l-.33-.27a.47.47 0 0 0-.66.07c-.16.2-.13.5.07.66l.63.52-.64.5a.47.47 0 0 0-.09.65c.16.2.45.25.66.1v-.01l.35-.28v.45a.47.47 0 1 0 .94 0v-.42l.33.26c.2.17.5.14.66-.07.16-.2.13-.5-.07-.66Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m7 18.65-.63-.52.65-.5c.2-.16.24-.45.08-.66a.46.46 0 0 0-.65-.09l-.36.28v-.44a.47.47 0 1 0-.94 0v.42l-.32-.27a.47.47 0 0 0-.66.07c-.16.2-.13.5.07.66l.63.52-.64.5a.47.47 0 0 0-.1.66c.16.2.46.24.66.08h.01l.35-.28v.45a.47.47 0 1 0 .94 0v-.42l.33.26c.2.17.49.14.65-.06.17-.2.13-.5-.07-.66Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m11.02 15.52-.63-.51.64-.5c.2-.16.25-.46.1-.66a.47.47 0 0 0-.66-.1v.01l-.36.28v-.45a.47.47 0 1 0-.94 0v.42l-.32-.26a.47.47 0 0 0-.66.07c-.16.2-.13.5.07.66l.63.51-.64.5a.47.47 0 0 0-.1.66c.17.2.46.24.66.09h.01l.35-.28v.44a.47.47 0 1 0 .94 0v-.42l.33.27a.47.47 0 0 0 .6-.72l-.01-.01Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m14.8 18.65-.64-.52.64-.5c.2-.16.25-.45.09-.66a.47.47 0 0 0-.66-.09l-.35.28v-.44a.47.47 0 1 0-.94 0v.42l-.33-.27a.47.47 0 0 0-.65.07c-.17.2-.13.5.07.66l.63.52-.64.5a.47.47 0 0 0 .57.74l.35-.28v.45a.47.47 0 1 0 .94 0v-.42l.32.26c.2.17.5.14.66-.06.16-.2.13-.5-.07-.66Z",
    fill: "#E6E6E6"
  }));
};
var _default = exports.default = brandedsnowsm;